import {kpiIconBackgroundColour} from "../../style/styleConsts";
import styled from "styled-components";
import React from "react";
import {Tooltip} from "antd";

const Kpi = styled.div`
   display: inline-block;
   background-color: ${kpiIconBackgroundColour};
   color: white;
   border-radius: 3px;
   padding: 1px 4px;
   font-size: 80%;
   margin-left: 5px;
   vertical-align: 10%;
`;

export default Kpi;

export const KpiTooltip = () => (
    <Tooltip title="Key Performance Indicator: The metric that determines the ranking order."
             mouseLeaveDelay={0}>
        <Kpi>KPI</Kpi>
    </Tooltip>
);


function kpiDisplayName(kpi) {
    switch (kpi) {
        case "absolutePnl":
            return `Absolute PnL`;
        case "relativePnl":
            return `Relative PnL`;
        case "absoluteReturnPercent":
            return "Absolute Return";
        case "relativeReturnPercent":
            return "Relative Return";
        case "absoluteHitRate":
            return "Absolute Hit Rate";
        case "relativeHitRate":
            return "Relative Hit Rate";
        case "customScore":
            return "Performance & Participation Score";
        default:
            return kpi;
    }
}


export function kpiDescription(kpi, currency) {
    if (!kpi) {
        return "";
    }
    return kpiDisplayName(kpi) + (kpi.substr(-3) === "Pnl" ? " (" + currency + ")" : "");
}


export function performanceValueSlimDescription(fieldName) {
    if (!fieldName) {
        return "";
    }
    switch (fieldName) {
        case "absolutePnl":
            return `Abs PnL`;
        case "relativePnl":
            return `Rel PnL`;
        case "absoluteReturnPercent":
            return "Abs Ret";
        case "relativeReturnPercent":
            return "Rel Ret";
        case "absoluteHitRate":
            return "Abs Hit Rate";
        case "relativeHitRate":
            return "Rel Hit Rate";
        case "customScore":
            return "P & P Score";
        case "normalisedReturn":
            return "Normalised Ret";
        default:
            return fieldName[0].toUpperCase() + fieldName.slice(1);
    }
}

export function kpiBriefDescription(kpi, currency) {
    const desc = performanceValueSlimDescription(kpi);

    switch (kpi) {
        case "absolutePnl":
        case "relativePnl":
            return `${desc} (${currency})`;
        default:
            return desc;
    }
}

function isRelative(kpi) {
    return kpi && kpi.startsWith("rel");
}

export function compactKpiDescription(kpi, benchmarkSource, defaultBenchmark) {
    const basic = "My " + kpiDisplayName(kpi);
    if (!isRelative(kpi)) {
        return basic;
    }
    return basic + ((benchmarkSource || defaultBenchmark) ? " (" + benchmarkingUsed(kpi, benchmarkSource, defaultBenchmark) + ")" : "");
}

export function benchmarkingDescriptionFrom(kpi, benchmarkSource, defaultBenchmark) {
    if (!isRelative(kpi)) {
        return "";
    }
    switch (benchmarkSource) {
        case "DefaultBenchmark":
            return defaultBenchmark;
        case "ContributorThenDefault":
            return "Author specific";
        case "LocalCountryThenDefault":
            return "Local Country";
        case "LocalSectorThenDefault":
            return "Local Sector";
        case "ContributorThenLocalCountryThenDefault":
            return "Author then Local Country";
        case "ContributorThenLocalSectorThenDefault":
            return "Author then Local Sector";
        default:
            return "";
    }
}

function formatBenchmarkSource(benchmarkSource) {
    switch (benchmarkSource) {
        case "LocalCountry":
            return "Country";
        case "LocalSector":
            return "Sector";
        default:
            return benchmarkSource || "";
    }
}

export function benchmarkingUsed(kpi, benchmarkSource, commonBenchmark) {
    if (!isRelative(kpi)) {
        return "";
    }
    return commonBenchmark || formatBenchmarkSource(benchmarkSource);
}